import { schemaKey } from "@redotech/zod-util/schema-key";
import * as z from "zod";

const input = z.object({ includeOriginTemplates: z.boolean().optional() });

export const getEmailTemplateNames = {
  name: "getEmailTemplateNames" as const,
  description: `Lists the team's email templates by id and name. ${schemaKey(input, "includeOriginTemplates")} adds the shared origin templates.`,
  mutates: false,
  input,
  output: z.object({
    emailTemplates: z.array(z.object({ id: z.string(), name: z.string() })),
    // TODO(2026-11-15): remove once merchant app tabs loaded before
    // emailTemplates existed have reloaded; they still require this field.
    emailTemplateIdToNameMap: z.map(z.string(), z.string()),
  }),
};
